import React, {useState} from 'react'
import {useDispatch, useSelector} from "react-redux";

// actions
import { hydrate } from '~/slices/carts/cart'
import { addCatalogCodes, resetCatalogCodes } from '~/slices/items/itemSearchOption'
import { openBar } from '~/slices/commons/snackbar'

// components
import {POST_METHOD, promiseCallApi} from "../../../../../stores/tools/commons";
import InputCatalogCode from "./inputCatalogCode";
import {css} from "@emotion/react";
import colorPalette from "../../../../../styles/theme/colorPalette";
import NeutralButton from "../../../../atoms/NeutralButton";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

export const CatalogCodeTab = (props) => {
  const dispatch = useDispatch()
  const tabId = useSelector((state) => state.searchDrawerTab.id)
  const cartState = useSelector((state) => state.cart)
  const searchCatalogCodesState = useSelector((state) => state.itemSearchOption.searchCatalogCodes)
  const customerState = useSelector((state) => state.customer)
  const sendCart = () => {
    const params = {
      customerId: customerState.info && customerState.info.id,
      cart: cartState,
      catalogCodes: Object.values(searchCatalogCodesState),
    }
    promiseCallApi(process.env.NEXT_PUBLIC_API_BASE_URL + "/api/v1/carts/insert_cart?", POST_METHOD, params).then(res => {
      dispatch(hydrate(res.data.cart))
      if (res.data.errors.length == 0) {
        dispatch(openBar({message: 'カートに商品を追加しました', variant: 'success'}))
      } else {
        dispatch(openBar({message: 'カートに商品を追加しましたが、一部商品に欠品がありました', variant: 'warning'}))
      }
    }).catch((res) => {
      // カートに追加できなかった商品の処理
      console.log(res)
    })
    dispatch(resetCatalogCodes())
  }

  const addField = () => {
    const ids = Object.keys(searchCatalogCodesState).map((id) => Number(id))
    const maxId = Math.max(...ids)
    dispatch(addCatalogCodes(maxId))
  }

  const resetField = () => {
    dispatch(resetCatalogCodes())
  }

  return (
      <>
        {
          props.value === tabId &&
          <>
            <div css={{maxHeight: 'calc(100vh - 307px)', overflowY: 'auto', overflowX: 'hidden', paddingBottom:'16px'}}>
              {
                Object.keys(searchCatalogCodesState).map((id, index) => (
                    <InputCatalogCode key={id + searchCatalogCodesState[id].code} fieldId={id} codeData={searchCatalogCodesState[id]} />
                ))
              }
            </div>
            <div css={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div css={addBtn}>
                <NeutralButton
                    text='＋ 入力欄を増やす'
                    hexColorCode={colorPalette.gray}
                    onClick={() => addField()}
                    minWidth={'260px'}
                />
              </div>
              <div css={insertBtn}>
                <NeutralButton
                    text='入力した商品をカートに入れる'
                    hexColorCode={colorPalette.primary}
                    onClick={() => sendCart()}
                    minWidth={'280px'}
                    endAdornment={
                      <ArrowRightIcon />
                    }
                    style={{backgroundColor: colorPalette.primary, color: 'white'}}
                />
              </div>
            </div>
          </>
        }
      </>
  )
}


const addBtn = css`
  text-align: center;
  margin: 2rem 0 1rem;
`

const insertBtn = css`
  text-align: center;
  margin: 1rem 0 2rem;
`